/**
 * HomeRedirect
 *
 * Landing "raiz" do /app.
 * - Se platform_owner → /app/plataforma-tenants
 * - Senão → renderiza o Hub principal (acesso rápido puro)
 *
 * O Dashboard analítico (com KPIs e gráficos) continua acessível em
 * /app/dashboard para quem quiser a visão executiva completa.
 */
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Hub from "@/pages/Hub";

export function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (
    user?.role === "commercial_master" ||
    user?.role === "commercial_consultant"
  ) {
    return <Navigate to="/commercial-portal" replace />;
  }

  if (user?.role === "platform_owner") {
    return <Navigate to="/app/plataforma-inicio" replace />;
  }

  return <Hub />;
}
